import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractFilter } from './abstract-filter.model';

@Component({
  selector: 'ap-filter-item',
  templateUrl: './filter-item.component.html',
  styleUrls: ['./filter-item.component.css']
})
export class FilterItemComponent {

  @Input() filter: AbstractFilter;

  @Output() remove = new EventEmitter<AbstractFilter>();

  @Output() edit = new EventEmitter<AbstractFilter>();

  @Output() disable = new EventEmitter<AbstractFilter>();

  constructor() {
  }

  onRemove() {
    this.remove.emit(this.filter);
  }

  onEdit() {
    this.edit.emit(this.filter);
  }

  onDisable() {
    this.filter.enabled = !this.filter.enabled;
    this.disable.emit(this.filter);
  }

}
